import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_transfer_ownership_proposal_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_DELETE,
  payload,
});

export const init_local_workspace_transfer_ownership_proposal_delete = (state: STATE__workspace, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.transfer_ownership_proposals_map.delete(id);
  }

  //refresh map to trigger re-render
  state.transfer_ownership_proposals_map = new Map(state.transfer_ownership_proposals_map);
};
